export default "__VITE_ASSET__gHTE$wnn__"